import { MatSpinner } from '@angular/material/progress-spinner';
import { Component, inject, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { ActivatedRoute } from '@angular/router';
import { AssureService } from '../../service/assure-service';
import { Assure, Vehicule, GarantieI, Assurance, Remorque, ModalListItemI, ListItem } from '../../../shared/model';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import {  MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import {  UpperCasePipe } from '@angular/common';
import { MatDialog} from '@angular/material/dialog';
import { ToastrService } from '../../../shared/services/toastr-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { MatListModule } from '@angular/material/list';
import { PrintService } from '../../../shared/services/print-service';
import { VehiculeComponentModal } from '../modal/modal-vehicule';
import { AssuranceComponentModal } from '../modal/modal-assurance';
import { A11yModule } from "@angular/cdk/a11y";
import { PrintLinkComponentModal } from '../modal/modal-print-link';
import { ListModalComponent } from '../../../shared/components/list-modal-component/list-modal-component';
import { VehiculeService } from '../../service/vehicule-service';


export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Vehicule,
  assurance ?: any,
  assure ?: Assure,
  garanties ?:GarantieI[],
}

export interface VehiculeInFos{
  name_marque : string
  region ?: string
  type ?: string
  models : string[]
}

export interface ModalRemorqueDataI{
  title : string,
  assurance_id : string,
  assure_id : string,
  zone : string,
  periode : number
  categorie : string,
  compagnie_id : string,
  compagnie_name : string,
  remorque : boolean
}


@Component({
  selector: 'app-assure-detail-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    UpperCasePipe,
    UpperCasePipe,
    MatSpinner,
    MatListModule,
    A11yModule
],
  templateUrl: './assure-detail-component.html',
  styleUrl: './assure-detail-component.css',
})
export class AssureDetailComponent {

  displayedColumns: string[] = [/*'id',*/ 'immatriculation', 'chassis', 'name', /*'nature',*/ 'genre', 'energie', 'puissance', 'place', 'status', 'actions'];
  dataSource: MatTableDataSource<Vehicule> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  assure_id : string = ""
  currentAssure = signal<Assure>(new Assure())
  vehicules = signal<Vehicule[]>([])

  readonly dialog = inject(MatDialog);
  loading = signal(false)
  saveLoading = false
  vehiculeTracteurLoading = signal(false)

  printService = inject(PrintService)

  title = signal<string>('')

  constructor(
    private route : ActivatedRoute,
    private assureService : AssureService,
    private toastr : ToastrService,
    private sweetAlert : SweetAlertService,
    private vehiculeService : VehiculeService
  ){

  }

  ngOnInit(): void {
    this.route.params.subscribe((res) => this.assure_id = res['id'])
    this.loadAssureData()
  }

    loadAssureData(){
      this.loading.update(val => true)
      this.assureService.get(this.assure_id).subscribe(
        (assure) => {
          this.currentAssure.update((val) => assure)
          if(this.currentAssure().personne == 'physique')
            this.title.update(val => 'Assure : '+this.currentAssure()?.firstname+' '+(this.currentAssure()?.lastname??''))
          else
            this.title.update(val => 'Assure : '+this.currentAssure()?.societe)

          this.dataSource.data = this.currentAssure().vehicules
          this.loading.update(val => false)
        },
        (err) => {this.loading.update(val => false)}
      )
    }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;


  }

  openPrintLink(id : string){
    const dialogRef = this.dialog.open(PrintLinkComponentModal, {
      width: '800px',
      height : '400px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : {id : id, avenant : false}
    });
  }

  selectVehiculeTracteur(remorque : Vehicule){
    this.vehiculeTracteurLoading.update(val => true)
    this.vehiculeService.vehiculeTracteurAssure(this.currentAssure().id).subscribe({
      next : (res) =>{
          this.vehiculeTracteurLoading.update(val => false)
          if(res.length == 0){
            this.openAssuranceModal(remorque)
            return;
          }
          const data : ModalListItemI = {
            title : "Liste des vehicules Tracteurs",
            action : "Passer",
            data : res.slice().map(item => {
              return {id : item.id, name : (item.marque+" "+item.model+" ( "+item.immatriculation+" ) ").toUpperCase()}
            })
          }

          const dialogRef = this.dialog.open(ListModalComponent, {
              width : '700px',
              enterAnimationDuration : '500ms',
              exitAnimationDuration : '500ms',
              disableClose : true,
              data : data
          });

          dialogRef.afterClosed().subscribe((result : ListItem) => {
            remorque['tracteur_id'] = result.id
            this.openAssuranceModal(remorque)
          });
      },
      error : (err) =>{
          this.vehiculeTracteurLoading.update(val => false)
      }
    })

  }

  openAddVehiculeModal(){
    const data : ModalDataI = {
      title : '',
      data : new Vehicule(),
      assure : this.currentAssure()
    }

    const dialogRef = this.dialog.open(VehiculeComponentModal, {
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data,
      width: '900px'
    });

    dialogRef.afterClosed().subscribe((result : Vehicule) => {

      if (result?.id != undefined) {
        const data : Vehicule[] = []
        data.push(...this.dataSource.data)
        data.push(result)
        this.dataSource.data = data
        this.toastr.success("Le vehicule "+ result.marque +' '+ result.model + " à été ajouté")
      }
    });
  }

  openUpdateVehicule(vehicule : Vehicule){
    const data : ModalDataI = {
      title :  vehicule.marque +' ' + vehicule.model,
      update : true,
      data : vehicule,
      assure : this.currentAssure()
    }

    const dialogRef = this.dialog.open(VehiculeComponentModal, {
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data,
      width: '900px'
    });

    dialogRef.afterClosed().subscribe((result : Vehicule) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("Le vehicule "+ name + " à été modifie")
      }
    });
  }

  openAssuranceModal(vehicule : Vehicule){
    const data : ModalDataI = {
      title : vehicule.marque+' '+vehicule?.model+' ( '+vehicule.immatriculation+' )',
      data : vehicule,
      assure : this.currentAssure()
    }

    const dialogRef = this.dialog.open(AssuranceComponentModal, {
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Assurance) => {
      if (result?.id) {
        this.loadAssureData()
        this.openPrintLink(result.id)
      }
    });
  }

  openRemorqueModal(vehicule : Vehicule){
    const data : ModalRemorqueDataI = {
      title : 'Assurer une remorque',
      assurance_id : vehicule.assurance_id,
      categorie : vehicule.categorie!,
      periode : vehicule.periode!,
      zone : vehicule.zone!,
      compagnie_id : vehicule.compagnie_id!,
      compagnie_name : vehicule.compagnie_name!,
      assure_id : vehicule.assure_id,
      remorque : true
    }

    const dialogRef = this.dialog.open(AssuranceComponentModal, {
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Assurance) => {

      if (result?.id != "") {
        this.loadAssureData()
      }
    });
  }


  confirm(vehicule : Vehicule){

    this.sweetAlert
    .confirm("Etez-vous sur de vouloir supprimer le vehicule "+ vehicule.marque +' ' + vehicule.model)
    .then((res) =>{
      if(res.isConfirmed){
        this.assureService.delete(vehicule.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != vehicule.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  applyFilter(event : string){
    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}



